"use strict";
// This file is auto-generated by @hey-api/openapi-ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEnergyTaxRecordV1 = exports.putBoardapproveV1 = exports.putPublishV1 = exports.putTariffPlanStatusV1 = exports.putEnddateV1 = exports.getProductsWithTariffPlansV1 = exports.putTariffplansV1 = exports.getTariffplansV1 = exports.createTariffPlanV1 = exports.getProductV1 = exports.getProductsV1 = exports.getDynamicPricesByDateV2 = exports.getDynamicPricesByDate = exports.getDynamicPrices = exports.getDynamicPricesAvailability = void 0;
/**
 * Gets for which period dynamic prices are available.
 * @returns GetDynamicPricesAvailabilityResponse OK
 * @throws ApiError
 */
const getDynamicPricesAvailability = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/tariffmanagement/dynamic-prices/availability/v1',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getDynamicPricesAvailability = getDynamicPricesAvailability;
/**
 * Gets dynamic prices for yesterday, today and tomorrow.
 * @returns GetDynamicPricesResponse OK
 * @throws ApiError
 */
const getDynamicPrices = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/tariffmanagement/dynamic-prices/v1',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getDynamicPrices = getDynamicPrices;
/**
 * Gets dynamic prices for a specific date.
 * @param data The data for the request.
 * @param data.date The query date, this is in local timezone: Europe/Amsterdam.
 * @returns GetDynamicPricesByDateResponse OK
 * @throws ApiError
 */
const getDynamicPricesByDate = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/tariffmanagement/dynamic-prices/v1/{date}',
        path: {
            date: data.date
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getDynamicPricesByDate = getDynamicPricesByDate;
/**
 * Gets dynamic prices for a specific date.
 * @param data The data for the request.
 * @param data.date The query date, this is in local timezone: Europe/Amsterdam.
 * @returns GetDynamicPricesByDateResponse OK
 * @throws ApiError
 */
const getDynamicPricesByDateV2 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/tariffmanagement/dynamic-prices/{date}/v2',
        path: {
            date: data.date
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getDynamicPricesByDateV2 = getDynamicPricesByDateV2;
/**
 * Gets all products
 * @returns GetProductsResponse OK
 * @throws ApiError
 */
const getProductsV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/tariffmanagement/tariff-management-app/products/v1',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getProductsV1 = getProductsV1;
/**
 * Gets a single product
 * @param data The data for the request.
 * @param data.productId
 * @returns GetProductResponse OK
 * @throws ApiError
 */
const getProductV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/tariffmanagement/tariff-management-app/products/{productId}/v1',
        path: {
            productId: data.productId
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getProductV1 = getProductV1;
/**
 * Create a tariff plan
 * @param data The data for the request.
 * @param data.productId
 * @param data.requestBody
 * @returns createTariffPlanResponse OK
 * @throws ApiError
 */
const createTariffPlanV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/tariffmanagement/tariff-management-app/products/{productId}/tariff-plans/v1',
        path: {
            productId: data.productId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.createTariffPlanV1 = createTariffPlanV1;
/**
 * Get single tariff plan
 * @param data The data for the request.
 * @param data.productId
 * @param data.tariffPlanId
 * @returns getTariffPlanResponse OK
 * @throws ApiError
 */
const getTariffplansV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/tariffmanagement/tariff-management-app/products/{productId}/tariff-plans/{tariffPlanId}/v1',
        path: {
            productId: data.productId,
            tariffPlanId: data.tariffPlanId
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getTariffplansV1 = getTariffplansV1;
/**
 * Edit a tariff plan
 * @param data The data for the request.
 * @param data.productId
 * @param data.tariffPlanId
 * @param data.requestBody
 * @returns editTariffPlanResponse OK
 * @throws ApiError
 */
const putTariffplansV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'PUT',
        url: '/tariffmanagement/tariff-management-app/products/{productId}/tariff-plans/{tariffPlanId}/v1',
        path: {
            productId: data.productId,
            tariffPlanId: data.tariffPlanId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.putTariffplansV1 = putTariffplansV1;
/**
 * Gets all products with the latest tariff plan for each duration
 * @param data The data for the request.
 * @param data.status
 * @returns GetProductsWithLatestTariffPlansResponse OK
 * @throws ApiError
 */
const getProductsWithTariffPlansV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/tariffmanagement/tariff-management-app/products/tariff-plans/v1',
        query: {
            status: data.status
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getProductsWithTariffPlansV1 = getProductsWithTariffPlansV1;
/**
 * End a tariff plan
 * @param data The data for the request.
 * @param data.productId
 * @param data.tariffPlanId
 * @param data.requestBody
 * @returns void OK
 * @throws ApiError
 */
const putEnddateV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'PUT',
        url: '/tariffmanagement/tariff-management-app/products/{productId}/tariff-plans/{tariffPlanId}/end-date/v1',
        path: {
            productId: data.productId,
            tariffPlanId: data.tariffPlanId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.putEnddateV1 = putEnddateV1;
/**
 * Update the status of one or more tariff plans
 * @param data The data for the request.
 * @param data.requestBody
 * @returns void OK
 * @throws ApiError
 */
const putTariffPlanStatusV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'PUT',
        url: '/tariffmanagement/tariff-management-app/tariff-plans/status/v1',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.putTariffPlanStatusV1 = putTariffPlanStatusV1;
/**
 * Publish one or more tariff plans
 * @param data The data for the request.
 * @param data.requestBody
 * @returns void OK
 * @throws ApiError
 */
const putPublishV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'PUT',
        url: '/tariffmanagement/tariff-management-app/tariff-plans/publish/v1',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.putPublishV1 = putPublishV1;
/**
 * Give board approval to one or more tariff plans
 * @param data The data for the request.
 * @param data.requestBody
 * @returns void OK
 * @throws ApiError
 */
const putBoardapproveV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'PUT',
        url: '/tariffmanagement/tariff-management-app/tariff-plans/board-approve/v1',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.putBoardapproveV1 = putBoardapproveV1;
/**
 * Create a new energy tax record
 * @param data The data for the request.
 * @param data.requestBody
 * @returns EnergyTaxRecord OK
 * @throws ApiError
 */
const createEnergyTaxRecordV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/tariffmanagement/tariff-management-app/energy-tax-records/v1',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.createEnergyTaxRecordV1 = createEnergyTaxRecordV1;
